<template>
  <div>
    <div class="marTML pf23-subTit">
      <div class="widM fntH4 bold padTS padBS" style="color:#fff;">참가자 정보</div>
    </div>
    <div class="widM padTSM">
      <ul class="osResNoticeList fntE colorGray" style="padding-left:.5em; text-indent:-.5em;">
        <li>- <em style="color:#e11e45">*</em> 표시는 필수 입력사항입니다.</li>
        <li>- 첨부파일은 JPG, PNG, PDF, HEIC, HEIF 형식으로 최대 10MB까지 등록하실 수 있습니다.</li>
      </ul>
    </div>

    <div class="pf23-inFo-wrap">
      <div class="widM clearfix" v-if="mainResponses"> 
        <template v-for="(mainAttendant, idx) in mainResponses" >
          <SurveyParticipant
            :key="`mainAttendant${idx}`"
            :seq="idx"
            :participant="mainAttendant"
          />
          <span
            :key="`mainAttendant_span${idx}`"
            class="disIb moOnly" style="padding:2.5px;"
          />
          <hr
            v-if="idx < mainResponses.length - 1"
            :key="`mainAttendant_hr${idx}`"
            class="moOnly"
            style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"
          />
        </template>
      </div>

      <!-- 안전 확인 : PC 인 경우는 주/부 에 대해서 표시된다. Mo 인 경우는 부 or 배우자인경우만 표시된다. 신기한 Style -->
      <SurveyParticipantSafe :infoAvailable="infoAvailable" />
      

      <template v-if="existMemberAttendant">
        <!-- 8.30 동반가족 정보 추가 -->
        <div class="pf23-family">
      
          <!-- 동반 가족 정보 -->
          <div class="marTML" style="background:#f4f4f4; border-top:2px solid #ddd;">
            <div class="widM fntH4 bold padTS padBS" style="color:#2c2c2c;">동반가족 정보</div>
          </div>

          <div class="widM">
            <div class="NCAcmi_family padTM">
              <div class="floL fntP">참여 여부 <span class="ico-must-astar"></span></div>
              <!-- 아래 div class .NCAcmi_family_attend 추가 --> 
              <div class="floR NCAcmi_family_attend"> 
              <!-- //아래 div class .NCAcmi_family_attend 추가 --> 
                <div class="amway-theme txtR ">
                  <!-- 아래 div class .NCAcmi_familyN 추가 -->
                  <div class="action NCAcmi_radioBtn radio-wrapper NCAcmi_family_radio NCAcmi_familyN">
                  <!-- //아래 div class .NCAcmi_familyN 추가 -->
                    <label class="amw-radio-wrap radio-label focus">
                      <input
                        type="radio"
                        name="radio-family"
                        class="amw-global-radio"
                        value="Y"
                        v-model="familyAttendanceYn"
                        :disabled="!infoAvailable"
                      />
                      <span class="amw-radio-overlay"></span>
                      <span class="amw-label-radio-text">참여</span>
                    </label>
                    <label class="amw-radio-wrap radio-label focus">
                      <input
                        type="radio"
                        name="radio-family"
                        class="amw-global-radio"
                        value="N"
                        v-model="familyAttendanceYn"
                        :disabled="!infoAvailable"
                      />
                      <span class="amw-radio-overlay"></span>
                      <span class="amw-label-radio-text">불참</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          <!-- 11.06 동반 가족 범위 도표 수정 -->
          <div class="widM marBML" id="familyChart">
            <div class="marTS padBS" style="background:#f5f5f5;">
              <div class="osResTbScrollWrap" style="border: none; box-shadow: none;">
                <div class="osResTbScroll"> 
                  <img src="../images/cont01_family_chart.png" class="" alt="새로운 동반 가족 범위(도표) - 기존 2촌 이내 가족에서 3촌 이내 가족으로 동반 가족 범위가 확대됩니다.">
                </div>
              </div>
            </div>
          </div>
          <!-- //11.06 동반 가족 범위 도표 수정 -->

          <template v-if="familyAttendanceYn === 'Y'">

            <!-- // 동반가족 Area -->
            <template v-for="(family, idx) in familyResponses">
              <hr
                :key="`familyResponses_hr${idx}`"
                style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"
              />
              <SurveyParticipantFamily
                :key="`familyResponses${idx}`"
                :idx="idx"
                :participant="family"
              />
            </template>
            <!-- // 동반가족 Area -->

            <!-- // 동반가족 추가 +버튼 -->
            <!-- 동반가족 추가 +버튼 클릭시 위의 동반가족 추가 form 생성 -->
            <!-- 동반가족 추가 비활성화 색상 변경 할 경우 a 에 .NCAcmi_familyN_Btn 추가 -->
            <!--<template v-if="infoAvailable && !isExceededFamilyCountLimit"> -->
            <template v-if="infoAvailable">
              <hr class="padBS" style="border-color: #ddd;">
              <a
                @click="addNewFamily"
                class="widM NCAcim_familyN_plus"
                :class="{ NCAcmi_familyN_Btn: !canAddFamily }"
                :style="{ cursor: canAddFamily ? 'pointer' : 'default' }"
              >
                <div class="padTSM padBSM" style="display:flex; justify-content: center; align-items: center;">
                  <div class="padRM"><img src="../images/NCAcmi_plus.png" alt="플러스 아이콘" style="max-width:30px;"></div>
                  <div class="txtL" style="color:#fff; line-height:2;">
                    <p class="fntP regular">동반가족 추가</p>
                  </div>
                </div>
              </a>
            </template>
            <!-- // 동반가족 추가 +버튼 -->

            <!-- // 동반가족 정보 모든 항목 입력 시 활성화 됨 NCAcim_familyN_plus-alert 출력 -->
            <div class="NCAcim_familyN_plus-alert widM">
              <p class="fntE marTS" style="color:#0075a4; text-indent: -0.6em; padding-left: 0.6em;">* 본인 포함 최대 4명까지만 참석 가능합니다.<br class="moOnly">
                (단, 동반가족이 직계 자녀로만 구성된 경우 제한 없음)</p>
            </div>
            <!-- // 동반가족 정보 모든 항목 입력 시 활성화 됨 NCAcim_familyN_plus-alert 출력-->

            <SurveyParticipantPayment 
              :isPayemntProcess="isPayemntProcess"
              >
            </SurveyParticipantPayment>
          </template>
        </div>
      </template>

    </div>

  </div>
</template>

<script>
import SurveyParticipant from './SurveyParticipant.vue'
import SurveyParticipantSafe from './SurveyParticipantSafe.vue'
import SurveyParticipantFamily from './SurveyParticipantFamily.vue'
import SurveyParticipantPayment from './SurveyParticipantPayment.vue'
import { SURVEY_SAPPORO, INFO_AVAILABLE, ATTENDING_LIST, MAIN_RESPONSES, FAMILY_RESPONSES, MEMBER_ATTENDANTS, SET_FAMILY_ATTENDANCE_YN
    , FAMILY_ATTENDANCE_YN, FAMILY_ATTENDANTS, ADD_NEW_FAMILY, GET_PERSONS_EXCLUDING_FAMILY , GET_CODE_PAYMENT_GUIDE, ACTIVITY_QUESTIONS
  } from '@/store/actions/survey'
import { mapState, mapGetters } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import { getMessage } from '@/utils/survey'

export default {
  name: 'SurveyParticipantInfo',
  mixins: [CommonMethodMixin],
  components: {
    SurveyParticipant,
    SurveyParticipantSafe,
    SurveyParticipantFamily,
    SurveyParticipantPayment,
  },
  computed: {
    ...mapState(SURVEY_SAPPORO, {
      responses: state => state.responses,
    }),
    ...mapGetters(SURVEY_SAPPORO, {
      infoAvailable: INFO_AVAILABLE,
      attendingList: ATTENDING_LIST,
      mainResponses: MAIN_RESPONSES,
      familyResponses: FAMILY_RESPONSES,
      familyAttendants: FAMILY_ATTENDANTS,
      family_attendance_yn: FAMILY_ATTENDANCE_YN,
      memberAttendants: MEMBER_ATTENDANTS,
      personsExcludingFamily: GET_PERSONS_EXCLUDING_FAMILY,
      paymentGuide: GET_CODE_PAYMENT_GUIDE,
      activityQuestions: ACTIVITY_QUESTIONS,
    }),
    existMemberAttendant () {
      return this.memberAttendants.length > 0;
      // return false
    },
    familyAttendanceYn: {
      get() {
        return this.family_attendance_yn;
      },
      set(yn) {
        this.$store.commit(`${SURVEY_SAPPORO}/${SET_FAMILY_ATTENDANCE_YN}`, yn);
      }
    },
    // 마지막 동반가족 추가 폼 작성 여부
    isFormFilledCompletely() {
      // 가족구성원이 아무도 없는 경우 
      if (this.familyResponses.length  === 0) return true;

      const lastFamilyIndex = this.familyResponses.length - 1;
      const lastFamily = this.familyResponses[lastFamilyIndex];
      const { name, questions, paymentInfo } = lastFamily;

      if(!name || name.trim() === '') {
        return false;
      }

      // 마지막 입력된 동반가족의 정보에서 오류가 있는지 체크 
      const lastFamilyErrors = Object.keys(questions)
            .filter(sq_code => !Object.keys(this.activityQuestions).includes(sq_code))
            .filter(sq_code => {
        const answer = Array.isArray(questions[sq_code]) ? questions[sq_code][0] : questions[sq_code];        
        if (answer.hasError) return true; 
      }); 

      // 미입력 항목이 있다면 alert 창으로 안내하고 종료한다. 
      if(lastFamilyErrors.length > 0) {
        return false;
      }
      
      // 결제 정보 체크(총 참석 인원수가 4명 이상 이면 결제 정보를 입력해야함)
      if(this.attendingList.length >= 10 && !paymentInfo) {
        return false;
      }

      return true;
    },
    // 동반가족 최대 동반 인원(8) 초과 여부
    isExceededFamilyCountLimit() {
      return this.attendingList.length >= 8;
    },
    // 동반가족 추가 버튼 활성화 가능 여부
    canAddFamily() { // 폼 작성 완료
      return this.isFormFilledCompletely && !this.isExceededFamilyCountLimit;
    },
    isPayemntProcess() { 
      return this.attendingList.length > 3
    },
  },
  methods: {
    addNewFamily(e) {
      // 마지막 동반인원이 입력항목이 모두 완성되었는지 확인 
      if (!this.isFormFilledCompletely)  { 
        alert(getMessage('ALERT_FAMILY_INPUT_MORE'));
        return false;
      }

      // 최대인원을 초과했는지 확인 
      if (this.isExceededFamilyCountLimit) { 
        alert(getMessage('ALERT_FAMILY_PERSON_LIMIT'));
        return false;
      }

      // if(!this.canAddFamily) return false;

      // 가족 구성원 체크 
      if(this.personsExcludingFamily >= 4) { 
        alert(getMessage('CONFIRM_ATTENDANT_RULE4'))
      }

      if(this.attendingList.length >= 3) {
        if(!confirm(getMessage('CONFIRM_ATTENDANT_RULE3'))) {
          return false;
        }
      }

      this.$store.dispatch(`${SURVEY_SAPPORO}/${ADD_NEW_FAMILY}`, 'Y');
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyParticipantInfo.vue